<template>
  <form @submit.prevent="" @keydown.enter.prevent="">
    <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 80vh; height: fit-content;">
      <header class="modal-card-head">
        <p class="modal-card-title">
          New Movement
          <span style="font-size:1rem; text-overflow: elipsis">{{ plant.name }}</span>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field grouped>
          <b-field label="Shift">
            <b-select v-model="shift" placeholder="Shift">
              <option value="AM">
                AM
              </option>
              <option value="PM">
                PM
              </option>
              <option value="Night">
                Night
              </option>
            </b-select>
          </b-field>
          <b-field label="Activity">
            <b-button v-if="availableActivities.includes('washing')" :type="operation == 'washing' ? 'is-success' : 'is-light'" @click="changeActivity('washing')">
              Manual Washing
            </b-button>
            <b-button v-if="availableActivities.includes('machineWash')" :type="operation == 'machineWash' ? 'is-success' : 'is-light'" @click="changeActivity('machineWash')">
              Machine Washing
            </b-button>
            <b-button v-if="availableActivities.includes('repair')" :type="operation == 'repair' ? 'is-success' : 'is-light'" @click="changeActivity('repair')">
              Repair
            </b-button>
            <b-button v-if="availableActivities.includes('quality')" :type="operation == 'quality' ? 'is-success' : 'is-light'" @click="changeActivity('quality')">
              Random Control
            </b-button>
            <b-button v-if="availableActivities.includes('forklift')" :type="operation == 'forklift' ? 'is-success' : 'is-light'" @click="changeActivity('forklift')">
              Forklift
            </b-button>
            <b-button v-if="availableActivities.includes('special')" :type="operation == 'special' ? 'is-success' : 'is-light'" @click="changeActivity('special')">
              Special
            </b-button>
            <b-button v-if="availableActivities.includes('clientPrep')" :type="operation == 'clientPrep' ? 'is-success' : 'is-light'" @click="changeActivity('clientPrep')">
              Client Preparation
            </b-button>
          </b-field>
          <b-field label="Crate Type">
            <b-select v-model="crateType" placeholder="Crate Type">
              <option v-for="type in crateTypeOptions" :key="type.value" :value="type.value">
                {{ type.name }}
              </option>
            </b-select>
          </b-field>
        </b-field>
        <!--
          The figures for a type that is not on screen are invisible by definition, and
          this form exists to stop operators declaring numbers they cannot see. The
          readout names every type a submit would write, and clicking one brings it back.
        -->
        <b-field v-if="pendingBatches.length > 0" label="Filled in so far">
          <div class="tags">
            <a
              v-for="batch in pendingBatches"
              :key="batch.type"
              class="tag"
              :class="batch.type === crateType ? 'is-info' : 'is-light'"
              @click="crateType = batch.type"
            >
              {{ batch.type }}&nbsp;&mdash;&nbsp;{{ batch.shifts.join(', ') }}
            </a>
          </div>
        </b-field>
        <div v-if="operation != null">
          <b-field class="mb-1" grouped>
            <b-field label="Date">
              <b-datepicker
                v-model="date"
                name="date"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Date"
              />
            </b-field>
            <div v-if="operation === 'washing' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'washing' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'washing' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'AM'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="amWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="amWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="amWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'PM'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="pmWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="pmWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="pmWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'Night'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="nightWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="nightWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="nightWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'AM'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="amMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="amMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="amMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'PM'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="pmMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="pmMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="pmMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'Night'">
          <b-field label="Quantity washed successfully" class="stock-clean">
            <b-input v-model="nightMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty" class="stock-dirty">
            <b-input v-model="nightMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair" class="stock-repair">
            <b-input v-model="nightMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'AM'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="amRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="amRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="amDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="amRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'PM'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="pmRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="pmRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="pmDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="pmRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'Night'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="nightRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="nightRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="nightDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="nightRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'AM'">
          <b-field label="Good Crates">
            <b-input v-model="amGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="amBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="amQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'PM'">
          <b-field label="Good Crates">
            <b-input v-model="pmGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="pmBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="pmQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'Night'">
          <b-field label="Good Crates">
            <b-input v-model="nightGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="nightBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="nightQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'AM' && !isClientCrateType">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="amForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="amForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="amForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="amForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="amForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="amForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="amForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="amForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="amForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="amForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'PM' && !isClientCrateType">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="pmForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="pmForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="pmForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="pmForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="pmForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="pmForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="pmForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="pmForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="pmForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="pmForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'Night' && !isClientCrateType">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="nightForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="nightForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="nightForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="nightForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received" class="flow-received">
              <b-input v-model="nightForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered" class="flow-delivered">
              <b-input v-model="nightForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="nightForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="nightForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="nightForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="nightForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <!--
          Client-specific types get their own panel rather than two more checkboxes on
          the special line, which already carries hours, crates, two type toggles and a
          comment. Preparation takes crates out of the ROOT type's dirty stock and puts
          them in this type's clean stock; declassification sends a soiled or damaged
          one back to the ordinary pool. Nothing else is declarable: these crates are
          already washed and repaired.
        -->
        <div v-if="operation === 'clientPrep' && isClientCrateType">
          <b-message type="is-info" size="is-small" has-icon>
            Prepared crates come out of the {{ selectedTypeDescriptor.root }} dirty stock and land in
            {{ crateType }} clean. Declassifying sends one back to {{ selectedTypeDescriptor.root }} dirty.
          </b-message>
          <div v-if="shift === 'AM'">
            <b-field class="mb-1" grouped>
              <b-field label="Prepared">
                <b-input v-model="amClientWashed" type="number" min="0" />
              </b-field>
              <b-field label="Declassified">
                <b-input v-model="amClientDeclassified" type="number" min="0" />
              </b-field>
              <b-field label="Hours">
                <b-input v-model="amClientHours" type="number" step="0.25" min="0" />
              </b-field>
              <b-field label="Comment" expanded>
                <b-input v-model="amClientComment" type="text" />
              </b-field>
            </b-field>
          </div>
          <div v-if="shift === 'PM'">
            <b-field class="mb-1" grouped>
              <b-field label="Prepared">
                <b-input v-model="pmClientWashed" type="number" min="0" />
              </b-field>
              <b-field label="Declassified">
                <b-input v-model="pmClientDeclassified" type="number" min="0" />
              </b-field>
              <b-field label="Hours">
                <b-input v-model="pmClientHours" type="number" step="0.25" min="0" />
              </b-field>
              <b-field label="Comment" expanded>
                <b-input v-model="pmClientComment" type="text" />
              </b-field>
            </b-field>
          </div>
          <div v-if="shift === 'Night'">
            <b-field class="mb-1" grouped>
              <b-field label="Prepared">
                <b-input v-model="nightClientWashed" type="number" min="0" />
              </b-field>
              <b-field label="Declassified">
                <b-input v-model="nightClientDeclassified" type="number" min="0" />
              </b-field>
              <b-field label="Hours">
                <b-input v-model="nightClientHours" type="number" step="0.25" min="0" />
              </b-field>
              <b-field label="Comment" expanded>
                <b-input v-model="nightClientComment" type="text" />
              </b-field>
            </b-field>
          </div>
        </div>
        <!--
          A client type's forklift moves are clean-only: the dirty, repair, yard-rejection
          and destruction rows of the generic panel cannot apply to crates that are
          already washed and repaired.
        -->
        <div v-if="operation === 'forklift' && isClientCrateType">
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field v-if="shift === 'AM'" label="Received" class="flow-received">
              <b-input v-model="amForklift.clean.received" type="number" />
            </b-field>
            <b-field v-if="shift === 'AM'" label="Delivered" class="flow-delivered">
              <b-input v-model="amForklift.clean.delivered" type="number" />
            </b-field>
            <b-field v-if="shift === 'PM'" label="Received" class="flow-received">
              <b-input v-model="pmForklift.clean.received" type="number" />
            </b-field>
            <b-field v-if="shift === 'PM'" label="Delivered" class="flow-delivered">
              <b-input v-model="pmForklift.clean.delivered" type="number" />
            </b-field>
            <b-field v-if="shift === 'Night'" label="Received" class="flow-received">
              <b-input v-model="nightForklift.clean.received" type="number" />
            </b-field>
            <b-field v-if="shift === 'Night'" label="Delivered" class="flow-delivered">
              <b-input v-model="nightForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field v-if="shift === 'AM'" label="Forklift comment">
              <b-input v-model="amForkliftComment" type="text" />
            </b-field>
            <b-field v-if="shift === 'PM'" label="Forklift comment">
              <b-input v-model="pmForkliftComment" type="text" />
            </b-field>
            <b-field v-if="shift === 'Night'" label="Forklift comment">
              <b-input v-model="nightForkliftComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'special'">
          <b-field v-for="(line, index) in specialLines" :key="`${shift}Special${index}`" class="mb-1" grouped>
            <b-field label="Hours">
              <b-input v-model="line.hours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Crates">
              <b-input v-model="line.crates" type="number" />
            </b-field>
            <b-field label="Type">
              <b-checkbox :value="line.maintenance" @input="setSpecialType(line, 'maintenance', $event)">
                Maintenance
              </b-checkbox>
              <b-checkbox :value="line.cleaning" @input="setSpecialType(line, 'cleaning', $event)">
                Cleaning
              </b-checkbox>
            </b-field>
            <b-field label="Comment" expanded>
              <b-input v-model="line.comment" type="text" />
            </b-field>
            <b-field label=" ">
              <b-button
                type="is-danger"
                icon-left="minus"
                style="margin-top: 50%;"
                :disabled="specialLines.length === 1"
                @click="removeSpecialLine(index)"
              />
            </b-field>
          </b-field>
          <b-button type="is-info" icon-left="plus" @click="addSpecialLine">
            Add special activity
          </b-button>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-info is-fullwidth" @click="submit">
          {{ $t('global.submit') }}
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
// import enduserClosureMail from '@/services/v3/enduserClosureMail'
import {
  SPECIAL,
  SPECIAL_CLEANING,
  SPECIAL_MAINTENANCE,
  SPECIAL_CLIENT_WASH,
  SPECIAL_CLIENT_DECLASSIFY,
  operationAllowedForType,
  specialMovementStatuses
} from '@/helpers/movementOperations'
import { declarableTypes, describeType } from '@/helpers/crateTypes'
import ClientCrateType from '@/services/v3/clientCrateType'
import TargetStock from '@/services/v3/targetStock'

// Every special line is saved as its own movement. Maintenance and cleaning are the
// two recurring ones, and ticking either names the operation instead of the comment.
function newSpecialLine () {
  return { hours: 0, crates: 0, comment: '', maintenance: false, cleaning: false }
}

// Everything an operator can type against one crate type: three shifts of every
// family's quantities, hours and comments. The type on screen is edited through the
// flat fields these become, and the types that are not are stashed in `entries`.
function newEntry () {
  return {
    // Client-specific types are declared with their own two quantities rather than
    // the generic special line, which is already full.
    amClientWashed: 0,
    amClientDeclassified: 0,
    pmClientWashed: 0,
    pmClientDeclassified: 0,
    nightClientWashed: 0,
    nightClientDeclassified: 0,
    amClientComment: '',
    pmClientComment: '',
    nightClientComment: '',
    amClientHours: 0,
    pmClientHours: 0,
    nightClientHours: 0,
    amWashedClean: 0,
    amWashedDirty: 0,
    amWashedRepair: 0,
    amMachineClean: 0,
    amMachineDirty: 0,
    amMachineRepair: 0,
    amRepairedCrates: 0,
    amRepairedDoors: 0,
    amGoodCrates: 0,
    amBadCrates: 0,
    amSpecial: [newSpecialLine()],
    amForklift: {
      dirty: {
        received: 0,
        delivered: 0
      },
      clean: {
        received: 0,
        delivered: 0
      },
      repair: {
        received: 0,
        delivered: 0
      },
      park: {
        cleanRejectedDirty: 0,
        cleanRejectedDirtyComment: '',
        cleanRejectedRepair: 0,
        cleanRejectedRepairComment: '',
        dirtyRejectedRepair: 0,
        dirtyRejectedRepairComment: ''
      },
      destroyed: {
        cleanDestroyed: 0,
        dirtyDestroyed: 0,
        repairDestroyed: 0
      }
    },
    amWashingComment: '',
    amMachineComment: '',
    amRepairComment: '',
    amForkliftComment: '',
    amQualityComment: '',
    amWashingHours: 0,
    amMachineHours: 0,
    amRepairHours: 0,
    amDoorHours: 0,
    amForkliftHours: 0,
    pmWashedClean: 0,
    pmWashedDirty: 0,
    pmWashedRepair: 0,
    pmMachineClean: 0,
    pmMachineDirty: 0,
    pmMachineRepair: 0,
    pmRepairedCrates: 0,
    pmRepairedDoors: 0,
    pmGoodCrates: 0,
    pmBadCrates: 0,
    pmSpecial: [newSpecialLine()],
    pmForklift: {
      dirty: {
        received: 0,
        delivered: 0
      },
      clean: {
        received: 0,
        delivered: 0
      },
      repair: {
        received: 0,
        delivered: 0
      },
      park: {
        cleanRejectedDirty: 0,
        cleanRejectedDirtyComment: '',
        cleanRejectedRepair: 0,
        cleanRejectedRepairComment: '',
        dirtyRejectedRepair: 0,
        dirtyRejectedRepairComment: ''
      },
      destroyed: {
        cleanDestroyed: 0,
        dirtyDestroyed: 0,
        repairDestroyed: 0
      }
    },
    pmWashingComment: '',
    pmMachineComment: '',
    pmRepairComment: '',
    pmForkliftComment: '',
    pmQualityComment: '',
    pmWashingHours: 0,
    pmMachineHours: 0,
    pmRepairHours: 0,
    pmDoorHours: 0,
    pmForkliftHours: 0,
    nightWashedClean: 0,
    nightWashedDirty: 0,
    nightWashedRepair: 0,
    nightMachineClean: 0,
    nightMachineDirty: 0,
    nightMachineRepair: 0,
    nightRepairedCrates: 0,
    nightRepairedDoors: 0,
    nightGoodCrates: 0,
    nightBadCrates: 0,
    nightSpecial: [newSpecialLine()],
    nightForklift: {
      dirty: {
        received: 0,
        delivered: 0
      },
      clean: {
        received: 0,
        delivered: 0
      },
      repair: {
        received: 0,
        delivered: 0
      },
      park: {
        cleanRejectedDirty: 0,
        cleanRejectedDirtyComment: '',
        cleanRejectedRepair: 0,
        cleanRejectedRepairComment: '',
        dirtyRejectedRepair: 0,
        dirtyRejectedRepairComment: ''
      },
      destroyed: {
        cleanDestroyed: 0,
        dirtyDestroyed: 0,
        repairDestroyed: 0
      }
    },
    nightWashingComment: '',
    nightMachineComment: '',
    nightRepairComment: '',
    nightForkliftComment: '',
    nightQualityComment: '',
    nightWashingHours: 0,
    nightMachineHours: 0,
    nightRepairHours: 0,
    nightDoorHours: 0,
    nightForkliftHours: 0
  }
}

// A stashed entry and the flat fields hold the same keys, which is what lets the
// two be swapped when the crate type selector changes.
const ENTRY_KEYS = Object.keys(newEntry())

const SHIFTS = ['AM', 'PM', 'Night']

// Detached from the reactive fields, so stashing one type and then editing another
// cannot write through to what was stashed.
function cloneEntry (entry) {
  return JSON.parse(JSON.stringify(entry))
}

export default {
  props: {
    plant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      date: new Date(),
      crateType: '5.2',
      // The plant's own crate types, and the client-specific ones its registry rows
      // grant it. Loaded in mounted; until then the form falls back to the full list.
      siteTypes: [],
      clientCrateTypes: [],
      // The figures typed against the crate types that are not on screen. The one that
      // is lives in the flat fields below; switching the selector swaps the two.
      entries: {},
      ...newEntry(),
      operation: null,
      shift: 'AM'
    }
  },
  computed: {
    specialLines () {
      return this.specialLinesFor(this.shift)
    },
    // The types this plant can declare against. '5.X' is deliberately expanded into
    // 5.2/5.5 and never offered: it is a reporting pool, and a movement written
    // against '5.X__DIRTY' would be stored and then ignored by the forecast for ever.
    crateTypeOptions () {
      return declarableTypes({ siteTypes: this.siteTypes, clientTypes: this.clientCrateTypes })
    },
    selectedTypeDescriptor () {
      return describeType(this.crateType, this.clientCrateTypes)
    },
    // A client type's crates are already washed and repaired, so the only things
    // declarable against one are preparation, declassification and moving the
    // finished crates. This drives which panels are offered.
    isClientCrateType () {
      return this.selectedTypeDescriptor.kind === 'client'
    },
    availableActivities () {
      if (this.isClientCrateType) return ['forklift', 'clientPrep']
      return ['washing', 'machineWash', 'repair', 'quality', 'forklift', 'special']
    },
    // Everything typed so far, the type on screen included. The readout and the submit
    // both work from this rather than from the visible fields alone.
    entriesByType () {
      return { ...this.entries, [this.crateType]: this.collectEntry() }
    },
    // What a submit would write, per crate type, and the lines the type cannot accept.
    typeBatches () {
      const order = this.crateTypeOptions.map(t => t.value)
      return Object.keys(this.entriesByType)
        .map((type) => {
          const built = this.buildMovements(type, this.entriesByType[type])
          return {
            type,
            movements: built.movements,
            rejected: built.rejected,
            shifts: SHIFTS.filter(shift => built.movements.some(m => m.shift === shift))
          }
        })
        .sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))
    },
    // The types the readout names and the confirmation lists. Read off the movements
    // rather than the fields, so figures that declare nothing -- hours with no crates,
    // a comment on its own -- are not announced as pending.
    pendingBatches () {
      return this.typeBatches.filter(batch => batch.movements.length > 0)
    }
  },
  watch: {
    // The type leaving the screen keeps its figures, and the one arriving gets back
    // whatever was typed against it earlier, or a blank form the first time.
    crateType (next, previous) {
      this.$set(this.entries, previous, this.collectEntry())
      this.applyEntry(cloneEntry(this.entries[next] || newEntry()))
      // Switching to a client type takes most families off the table, so an activity
      // that is no longer offered would leave the form showing nothing at all.
      if (this.operation && !this.availableActivities.includes(this.operation)) {
        this.operation = null
      }
    }
  },
  mounted: async function () {
    this.date.setDate(this.date.getDate() - 1)
    await this.loadCrateTypes()
  },
  methods: {
    async loadCrateTypes () {
      if (!this.plant || !this.plant.id) return
      try {
        const [targetStock, clientTypes] = await Promise.all([
          TargetStock.get({ id_site: this.plant.id }),
          ClientCrateType.getForSite(this.plant.id)
        ])
        this.clientCrateTypes = clientTypes || []
        this.siteTypes = targetStock && targetStock.length > 0 && targetStock[0].types
          ? JSON.parse(targetStock[0].types)
          : []
        // The list is now the plant's own, so the '5.2' default is no longer
        // guaranteed to be in it — a plant that does not hold 5.2 would open the
        // form on a type its dropdown cannot show.
        const options = this.crateTypeOptions
        if (options.length > 0 && !options.some(t => t.value === this.crateType)) {
          this.crateType = options[0].value
        }
      } catch (error) {
        // A configuration read failing must not block a declaration: fall back to the
        // full universal list, which is what the form offered before it was scoped.
        this.$buefy.toast.open({ type: 'is-warning', message: error.message || error, duration: 4000 })
      }
    },
    changeActivity (newActivity) {
      this.operation = newActivity
    },
    collectEntry () {
      const entry = {}
      ENTRY_KEYS.forEach((key) => { entry[key] = this[key] })
      return cloneEntry(entry)
    },
    applyEntry (entry) {
      ENTRY_KEYS.forEach((key) => { this[key] = entry[key] })
    },
    specialLinesOf (entry, shift) {
      if (shift === 'PM') return entry.pmSpecial
      if (shift === 'Night') return entry.nightSpecial
      return entry.amSpecial
    },
    clientFieldsFor (entry, shift) {
      if (shift === 'PM') {
        return { washed: entry.pmClientWashed, declassified: entry.pmClientDeclassified, comment: entry.pmClientComment, hours: entry.pmClientHours }
      }
      if (shift === 'Night') {
        return { washed: entry.nightClientWashed, declassified: entry.nightClientDeclassified, comment: entry.nightClientComment, hours: entry.nightClientHours }
      }
      return { washed: entry.amClientWashed, declassified: entry.amClientDeclassified, comment: entry.amClientComment, hours: entry.amClientHours }
    },
    // A control's good/bad split only reads as a rate against both counts, but the two
    // counts leave as two separate movements. Rather than add a column to the table, the
    // rate rides in front of the comment both movements already share.
    qualityComment (good, bad, comment) {
      const kept = Number(good) || 0
      const rejected = Number(bad) || 0
      if (kept + rejected <= 0) return comment
      let rate = Math.round(kept / (kept + rejected) * 1000) / 10
      // Rounding must never dress a handful of bad crates up as a clean 100%, or the
      // other way around.
      if (rate === 100 && rejected > 0) rate = 99.9
      if (rate === 0 && kept > 0) rate = 0.1
      const rateLabel = `${rate}%`
      return String(comment || '').trim() ? `${rateLabel}: ${comment}` : rateLabel
    },
    // Preparation and declassification straddle two types: the crates come out of the
    // root type's dirty stock and land in the client type's clean stock, and back.
    pushClientMovements (out, type, entry, shift) {
      const fields = this.clientFieldsFor(entry, shift)
      const descriptor = describeType(type, this.clientCrateTypes)
      const lines = [
        { operation: SPECIAL_CLIENT_WASH, crates: fields.washed },
        { operation: SPECIAL_CLIENT_DECLASSIFY, crates: fields.declassified }
      ]
      lines.forEach((line) => {
        if (!(line.crates > 0)) return
        const statuses = specialMovementStatuses(line.operation, type, descriptor)
        out.push({
          id_site: this.plant.id,
          status_crate_start: statuses.start,
          status_crate_end: statuses.end,
          num_crates: line.crates,
          operation: line.operation,
          comment: fields.comment,
          shift,
          hours: fields.hours,
          date: this.date.toLocaleDateString('en-CA')
        })
      })
    },
    specialLinesFor (shift) {
      return this.specialLinesOf(this.$data, shift)
    },
    addSpecialLine () {
      this.specialLines.push(newSpecialLine())
    },
    removeSpecialLine (index) {
      this.specialLines.splice(index, 1)
    },
    // A line is maintenance, or cleaning, or an untyped special activity: never two of them.
    setSpecialType (line, type, checked) {
      line.maintenance = checked && type === 'maintenance'
      line.cleaning = checked && type === 'cleaning'
    },
    specialOperation (line) {
      if (line.maintenance) return SPECIAL_MAINTENANCE
      if (line.cleaning) return SPECIAL_CLEANING
      return SPECIAL
    },
    // An untyped special activity is only identifiable by its comment, so hours without
    // one are rejected. A typed line already says what it was, and is let through. Every
    // crate type is checked, not just the one on screen: the others are submitted too.
    missingSpecialComments () {
      const missing = []
      Object.keys(this.entriesByType).forEach((type) => {
        SHIFTS.forEach((shift) => {
          this.specialLinesOf(this.entriesByType[type], shift).forEach((line, index) => {
            if (line.hours > 0 && this.specialOperation(line) === SPECIAL && String(line.comment).trim() === '') {
              missing.push(`${type} ${shift} line ${index + 1}`)
            }
          })
        })
      })
      return missing
    },
    // Every family's movements for one crate type, built from that type's figures
    // rather than from whichever panel happens to be on screen.
    buildMovements (type, entry) {
      const out = []
      if (entry.amWashedClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.amWashedClean,
            operation: 'washing',
            comment: entry.amWashingComment,
            shift: 'AM',
            hours: entry.amWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amWashedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.amWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: entry.amWashingComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amWashedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.amWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: entry.amWashingComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amMachineClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.amMachineClean,
            operation: 'machineWash',
            comment: entry.amMachineComment,
            shift: 'AM',
            hours: entry.amMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amMachineDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.amMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: entry.amMachineComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amMachineRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.amMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: entry.amMachineComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amRepairedCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.amRepairedCrates,
            operation: 'repair',
            comment: entry.amRepairComment,
            shift: 'AM',
            hours: entry.amRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amRepairedDoors > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DOOR`,
            status_crate_end: `${type}__DOOR`,
            num_crates: entry.amRepairedDoors,
            operation: 'repair__door',
            comment: entry.amRepairComment,
            shift: 'AM',
            hours: entry.amDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amGoodCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__GOOD`,
            status_crate_end: `${type}__GOOD`,
            num_crates: entry.amGoodCrates,
            operation: 'quality__good',
            comment: this.qualityComment(entry.amGoodCrates, entry.amBadCrates, entry.amQualityComment),
            shift: 'AM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amBadCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__BAD`,
            status_crate_end: `${type}__BAD`,
            num_crates: entry.amBadCrates,
            operation: 'quality__bad',
            comment: this.qualityComment(entry.amGoodCrates, entry.amBadCrates, entry.amQualityComment),
            shift: 'AM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.dirty.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.amForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.dirty.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.amForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.clean.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.amForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.clean.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.amForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.repair.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.amForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.repair.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.amForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.park.cleanRejectedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.amForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: entry.amForklift.park.cleanRejectedDirtyComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.park.cleanRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.amForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: entry.amForklift.park.cleanRejectedRepairComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.park.dirtyRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.amForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: entry.amForklift.park.dirtyRejectedRepairComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.destroyed.dirtyDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.amForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.destroyed.cleanDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.amForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.amForklift.destroyed.repairDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.amForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: entry.amForkliftComment,
            shift: 'AM',
            hours: entry.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      entry.amSpecial.forEach((line) => {
        if (line.hours > 0) {
          out.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${type}__SPECIAL`,
              status_crate_end: `${type}__SPECIAL`,
              num_crates: line.crates,
              operation: this.specialOperation(line),
              comment: line.comment,
              shift: 'AM',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      if (entry.pmWashedClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.pmWashedClean,
            operation: 'washing',
            comment: entry.pmWashingComment,
            shift: 'PM',
            hours: entry.pmWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmWashedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.pmWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: entry.pmWashingComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmWashedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.pmWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: entry.pmWashingComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmMachineClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.pmMachineClean,
            operation: 'machineWash',
            comment: entry.pmMachineComment,
            shift: 'PM',
            hours: entry.pmMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmMachineDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.pmMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: entry.pmMachineComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmMachineRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.pmMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: entry.pmMachineComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmRepairedCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.pmRepairedCrates,
            operation: 'repair',
            comment: entry.pmRepairComment,
            shift: 'PM',
            hours: entry.pmRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmRepairedDoors > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DOOR`,
            status_crate_end: `${type}__DOOR`,
            num_crates: entry.pmRepairedDoors,
            operation: 'repair__door',
            comment: entry.pmRepairComment,
            shift: 'PM',
            hours: entry.pmDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmGoodCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__GOOD`,
            status_crate_end: `${type}__GOOD`,
            num_crates: entry.pmGoodCrates,
            operation: 'quality__good',
            comment: this.qualityComment(entry.pmGoodCrates, entry.pmBadCrates, entry.pmQualityComment),
            shift: 'PM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmBadCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__BAD`,
            status_crate_end: `${type}__BAD`,
            num_crates: entry.pmBadCrates,
            operation: 'quality__bad',
            comment: this.qualityComment(entry.pmGoodCrates, entry.pmBadCrates, entry.pmQualityComment),
            shift: 'PM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.dirty.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.pmForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.dirty.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.pmForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.clean.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.pmForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.clean.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.pmForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.repair.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.pmForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.repair.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.pmForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.park.cleanRejectedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.pmForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: entry.pmForklift.park.cleanRejectedDirtyComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.park.cleanRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.pmForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: entry.pmForklift.park.cleanRejectedRepairComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.park.dirtyRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.pmForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: entry.pmForklift.park.dirtyRejectedRepairComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.destroyed.dirtyDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.pmForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.destroyed.cleanDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.pmForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.pmForklift.destroyed.repairDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.pmForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: entry.pmForkliftComment,
            shift: 'PM',
            hours: entry.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      entry.pmSpecial.forEach((line) => {
        if (line.hours > 0) {
          out.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${type}__SPECIAL`,
              status_crate_end: `${type}__SPECIAL`,
              num_crates: line.crates,
              operation: this.specialOperation(line),
              comment: line.comment,
              shift: 'PM',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      if (entry.nightWashedClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.nightWashedClean,
            operation: 'washing',
            comment: entry.nightWashingComment,
            shift: 'Night',
            hours: entry.nightWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightWashedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.nightWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: entry.nightWashingComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightWashedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.nightWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: entry.nightWashingComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightMachineClean > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.nightMachineClean,
            operation: 'machineWash',
            comment: entry.nightMachineComment,
            shift: 'Night',
            hours: entry.nightMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightMachineDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.nightMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: entry.nightMachineComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightMachineRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.nightMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: entry.nightMachineComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightRepairedCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.nightRepairedCrates,
            operation: 'repair',
            comment: entry.nightRepairComment,
            shift: 'Night',
            hours: entry.nightRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightRepairedDoors > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DOOR`,
            status_crate_end: `${type}__DOOR`,
            num_crates: entry.nightRepairedDoors,
            operation: 'repair__door',
            comment: entry.nightRepairComment,
            shift: 'Night',
            hours: entry.nightDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightGoodCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__GOOD`,
            status_crate_end: `${type}__GOOD`,
            num_crates: entry.nightGoodCrates,
            operation: 'quality__good',
            comment: this.qualityComment(entry.nightGoodCrates, entry.nightBadCrates, entry.nightQualityComment),
            shift: 'Night',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightBadCrates > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__BAD`,
            status_crate_end: `${type}__BAD`,
            num_crates: entry.nightBadCrates,
            operation: 'quality__bad',
            comment: this.qualityComment(entry.nightGoodCrates, entry.nightBadCrates, entry.nightQualityComment),
            shift: 'Night',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.dirty.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.nightForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.dirty.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.nightForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.clean.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__CLEAN`,
            num_crates: entry.nightForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.clean.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.nightForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.repair.received > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__RECEIVED`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.nightForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.repair.delivered > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DELIVERED`,
            num_crates: entry.nightForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.park.cleanRejectedDirty > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DIRTY`,
            num_crates: entry.nightForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: entry.nightForklift.park.cleanRejectedDirtyComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.park.cleanRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.nightForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: entry.nightForklift.park.cleanRejectedRepairComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.park.dirtyRejectedRepair > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__REPAIR`,
            num_crates: entry.nightForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: entry.nightForklift.park.dirtyRejectedRepairComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.destroyed.dirtyDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__DIRTY`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.nightForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.destroyed.cleanDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__CLEAN`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.nightForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (entry.nightForklift.destroyed.repairDestroyed > 0) {
        out.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${type}__REPAIR`,
            status_crate_end: `${type}__DESTROYED`,
            num_crates: entry.nightForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: entry.nightForkliftComment,
            shift: 'Night',
            hours: entry.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      entry.nightSpecial.forEach((line) => {
        if (line.hours > 0) {
          out.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${type}__SPECIAL`,
              status_crate_end: `${type}__SPECIAL`,
              num_crates: line.crates,
              operation: this.specialOperation(line),
              comment: line.comment,
              shift: 'Night',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      SHIFTS.forEach((shift) => this.pushClientMovements(out, type, entry, shift))

      // The blocks above build every family's movements from whatever quantities the
      // type holds, whichever activity button happens to be selected. Hiding a panel
      // with v-if therefore prevents nothing: a washing quantity typed before the type
      // became a client one would be written against it as an ordinary wash, inventing
      // dirty stock a client type can never hold. This is where that is enforced.
      const descriptor = describeType(type, this.clientCrateTypes)
      return {
        movements: out.filter(m => operationAllowedForType(m.operation, descriptor)),
        rejected: out.filter(m => !operationAllowedForType(m.operation, descriptor))
      }
    },
    // Filling several crate types means most of the day's figures are off screen when
    // submit is pressed, so the declaration is read back before anything is written.
    async submit () {
      const missingComments = this.missingSpecialComments()
      if (missingComments.length > 0) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: `A comment is required for every special activity with hours. Please fill out: ${missingComments.join(', ')}`,
          duration: 5000
        })
        return
      }
      const refused = this.typeBatches.filter(batch => batch.rejected.length > 0)
      refused.forEach((batch) => {
        this.$buefy.toast.open({
          type: 'is-warning',
          message: `${batch.rejected.length} line(s) were left out: ${[...new Set(batch.rejected.map(m => m.operation))].join(', ')} cannot be declared for ${batch.type}, which is already washed and repaired.`,
          duration: 5000
        })
      })
      const batches = this.pendingBatches
      if (batches.length === 0) {
        this.$buefy.toast.open({ type: 'is-warning', message: 'Nothing to declare: no quantity was filled in.', duration: 4000 })
        return
      }
      const summary = batches
        .map(batch => `<b>${batch.type}</b> ${batch.shifts.join(', ')} (${batch.movements.length} line${batch.movements.length > 1 ? 's' : ''})`)
        .join('<br>')
      this.$buefy.dialog.confirm({
        title: 'Confirm the declaration',
        message: `You are submitting, for <b>${this.date.toLocaleDateString('en-CA')}</b>:<br>${summary}<br><br>Is that right?`,
        confirmText: 'Submit',
        type: 'is-info',
        hasIcon: true,
        onConfirm: () => this.emitMovements(batches)
      })
    },
    emitMovements (batches) {
      const movements = batches.reduce((all, batch) => all.concat(batch.movements), [])
      try {
        this.$emit('submit', movements)
      } catch (error) {
        this.$buefy.toast.open({ type: 'is-danger', message: error.message, duration: 3000 })
      }
    }
  }
}
</script>

<style scoped>
/* Washing asks for three quantities that differ only by which stock they concern, and
   the labels are long enough to be read by shape rather than by word, so each field
   carries that stock's colour: green clean, pale orange dirty, red orange repair. A
   field that moves crates between two stocks takes the colour of the one they land in,
   since that is what the declaration changes.

   The forklift panel is coded the other way round. Its rows already name the stock, and
   what an operator puts on the wrong line there is the direction of the move, so the
   colour tells received from delivered instead. Its yard rejections are left untinted
   on purpose: they are neither, and one code per panel is what makes a code readable.

   b-input renders its <input> inside a child component, out of reach of a scoped style,
   hence the deep selectors. Only the background is tinted, so the focus ring Bulma
   draws on the border is left alone. */
.stock-clean >>> input {
  background-color: #e3f2e4;
}

.stock-dirty >>> input {
  background-color: #fdf4e7;
}

.stock-repair >>> input {
  background-color: #fbe3d8;
}

.flow-received >>> input {
  background-color: #fbe8d2;
}

.flow-delivered >>> input {
  background-color: #bfdedb;
}
</style>
